module.exports = __webpack_public_path__ + "img/house1_icon.8c8dff2f.png";